import { useEffect } from "react";

/* Lean pairing-success splash for low-powered kiosk screens.
   Opacity/transform-only animations (compositor work, no layout, no masks).
   Sits ABOVE the bottom bar (per-device offset via isTv), same region
   as the pairing-code screen.
   Choreography: rainbow dissolves in (0.9s) → beat of stillness →
   arcs build smallest→largest → MAGIC BEACON tracks in →
   CONNECTED! pops green → shimmer → dissolve off (~5.2s total). */

const TOTAL_MS = 5200;

const BeaconConnectSplash = ({ onDone, isTv = false }) => {
  useEffect(() => {
    // play the connect sound, honoring the user's volume setting
    try {
      const a = new Audio("/assets/doors/connection-chime.mp3");
      a.volume = Math.max(0.3, Number(localStorage.getItem("volume")) || 0);
      a.play().catch(() => {}); // autoplay-blocked → silent, animation still plays
    } catch (e) {}

    const t = setTimeout(() => onDone?.(), TOTAL_MS);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <div className="bcs" style={{ bottom: isTv ? "150px" : "90px" }}>
      <style>{`
        .bcs{position:fixed;top:0;left:0;right:0;z-index:99999;overflow:hidden;background:#050510;
          display:flex;flex-direction:column;align-items:center;justify-content:center;
          animation:bcsOut .8s ease-in 4.4s forwards;}
        .bcs-wipe{position:absolute;inset:0;opacity:0;
          animation:bcsFadeIn .9s ease-out forwards;
          background:conic-gradient(from -90deg at 50% 50%,
            #f5b400 0deg,#b03df0 55deg,#2b2bd6 105deg,#00c2d1 150deg,
            #1550c8 195deg,#d81a5f 250deg,#ff4d00 300deg,#f5b400 360deg);}
        .bcs-vig{position:absolute;inset:0;
          background:radial-gradient(ellipse at center,rgba(0,0,0,0) 30%,rgba(0,0,0,.5) 100%);}
        .bcs-shimmer{position:absolute;inset:-20%;
          background:linear-gradient(115deg,rgba(255,255,255,0) 42%,rgba(255,255,255,.2) 50%,rgba(255,255,255,0) 58%);
          transform:translateX(-120%);animation:bcsShimmer 1.1s ease-in-out 3.2s forwards;}
        .bcs-logo{position:relative;display:flex;flex-direction:column;align-items:center;}
        .bcs-mark{width:min(34vmin,340px);height:auto;overflow:visible;}
        .bcs-mark .p{opacity:0;transform-origin:50% 100%;
          animation:bcsArc .34s cubic-bezier(.34,1.5,.6,1) forwards;}
        .bcs-mark .d0{animation-delay:1.3s}.bcs-mark .d1{animation-delay:1.47s}
        .bcs-mark .d2{animation-delay:1.64s}.bcs-mark .d3{animation-delay:1.81s}
        .bcs-word{margin-top:3.2vmin;font-family:"Lato",Arial,sans-serif;font-weight:900;
          font-size:min(7.4vmin,74px);color:#fff;white-space:nowrap;opacity:0;
          letter-spacing:1.4em;padding-left:1.4em;
          text-shadow:0 0 18px rgba(255,255,255,.6);
          animation:bcsWord .9s cubic-bezier(.22,.9,.32,1) 2.2s forwards;}
        .bcs-conn{margin-top:2vmin;font-family:"Lato",Arial,sans-serif;font-weight:900;
          font-size:min(4.6vmin,46px);color:#05f651;white-space:nowrap;opacity:0;
          letter-spacing:.5em;padding-left:.5em;
          text-shadow:0 0 14px rgba(5,246,81,.8);
          animation:bcsConn .55s cubic-bezier(.34,1.5,.6,1) 2.85s forwards;}
        @keyframes bcsFadeIn{to{opacity:1}}
        @keyframes bcsArc{0%{opacity:0;transform:scale(.55)}70%{opacity:1;transform:scale(1.08)}100%{opacity:1;transform:scale(1)}}
        @keyframes bcsWord{0%{opacity:0;letter-spacing:1.4em}100%{opacity:1;letter-spacing:.42em}}
        @keyframes bcsConn{0%{opacity:0;transform:scale(.7)}70%{opacity:1;transform:scale(1.06)}100%{opacity:1;transform:scale(1)}}
        @keyframes bcsShimmer{to{transform:translateX(120%)}}
        @keyframes bcsOut{to{opacity:0;transform:scale(1.06)}}
      `}</style>
      <div className="bcs-wipe" />
      <div className="bcs-vig" />
      <div className="bcs-shimmer" />
      <div className="bcs-logo">
        <svg className="bcs-mark" viewBox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" stroke="#ffffff" strokeLinecap="round">
            <circle className="p d0" cx="100" cy="132" r="13" fill="#ffffff" stroke="none" />
            <path className="p d1" d="M 72 106 A 42 42 0 0 1 128 106" strokeWidth="17" />
            <path className="p d2" d="M 48 78 A 74 74 0 0 1 152 78" strokeWidth="17" />
            <path className="p d3" d="M 24 50 A 106 106 0 0 1 176 50" strokeWidth="17" />
          </g>
        </svg>
        <div className="bcs-word">MAGIC BEACON</div>
        <div className="bcs-conn">CONNECTED!</div>
      </div>
    </div>
  );
};

export default BeaconConnectSplash;
